<div class="column">
    <input #elRef type="text" [value]="value" (keyup)="onInputChange($event, elRef.value)" />
    @if (labelVisible()) {
        <span>HEX</span>
    }
</div>